import React from 'react';

import DateFormatter from './DateFormatter';
import NumericFormatter from './NumericFormatter';
import getIn from '../../connectedForm/utils/getIn';

export default function AttributeWorkspaceFormatter(props) {
  const { attributeConfig, attributeValues } = props.dependentValues;

  if (!attributeConfig || !attributeValues) {
    return <div />;
  }

  const attrId = attributeConfig.id;
  const value = attributeValues.find((attr) => attr.attributeConfig && attrId === attr.attributeConfig.id);

  const isOld = getIn(props, 'column.options.isOldRecord');

  if (!value) return <div />;
  switch (attributeConfig.attributeType) {
    case 'NUMERIC':
      return <NumericFormatter {...props} align="left" value={value[isOld ? 'oldDoubleValue' : 'doubleValue']} />;
    case 'INTEGER':
      return (
        <NumericFormatter
          {...props}
          type="integer"
          align="left"
          value={value[isOld ? 'oldIntegerValue' : 'integerValue']}
        />
      );
    case 'DATE':
      return <DateFormatter {...props} value={value[isOld ? 'oldDateValue' : 'dateValue']} />;
    case 'REFERENCE':
      const reference = value.referenceValue && value[isOld ? 'oldReferenceValue' : 'referenceValue'];
      const description = reference ? reference.description : '';
      return <div title={description}>{description}</div>;
    default:
      return <div title={value.textValue}>{value[isOld ? 'oldTextValue' : 'textValue']}</div>;
  }
}
